import { useState } from 'react';
import { Button } from '../ui/Button/Button';
import S from './AuthorizedDriversStyles';
import Modal from '../common/Modal/Modal';
import useGetAuthorizedDrivers from '../../API/hooks/vehicles/useGetAuthorizedDrivers';
import AuthorizedDriverItem from './AuthorizedDriverItem/AuthorizedDriverItem';
import AddDriverToVehicle from './AddDriverToVehicle/AddDriverToVehicle';
import { getSimpleEqQuery } from '../../utils/queryFilters';

type Props = {
  fleetId: string;
  vehicleId: string;
  onClose: () => void;
};

const compareByName = (a: any, b: any): number => {
  const driverA = `${a.driver.firstName} ${a.driver.lastName}`;
  const driverB = `${b.driver.firstName} ${b.driver.lastName}`;
  if (driverA < driverB) {
    return -1;
  }
  if (driverA > driverB) {
    return 1;
  }
  return 0;
};

function AuthorizedDrivers({
  onClose, vehicleId, fleetId,
}: Props): JSX.Element {
  const [submitError, setSubmitError] = useState<string | string[] | null>(null);
  const [addModalOpen, toggleAddModalOpen] = useState(false);

  const { data: authorizedDrivers, isLoading } = useGetAuthorizedDrivers(fleetId, vehicleId, `?limit=1000&skip=0${getSimpleEqQuery('vehicleId', vehicleId, 1)}`);

  const authorizedDriversList = authorizedDrivers?.results || [];

  return (
    <S.Wrapper>
      <div className="authorization-title">
        List of authorized drivers:
      </div>
      <div className="drivers">
        {authorizedDriversList.sort(compareByName).map((d: any) => (
          <AuthorizedDriverItem item={d} key={d._id} />
        ))}
        {!authorizedDriversList.length && !isLoading && (<div className="no-drivers">no authorized drivers for current vehicle</div>)}
        {isLoading && (<div className="no-drivers">Loading...</div>)}
      </div>
      {!!submitError && (
        typeof submitError === 'string'
          ? <S.ErrorMessage>{submitError}</S.ErrorMessage>
          : submitError.map((error) => <S.ErrorMessage>{error}</S.ErrorMessage>)
      )}
      <div className="actions">
        <Button
          className="button"
          padding="7px 40px"
          onClick={onClose}
        >Close
        </Button>
        <Button
          className="button"
          padding="7px 40px"
          onClick={() => toggleAddModalOpen(true)}
        >Add new driver
        </Button>
      </div>
      {addModalOpen && (
        <Modal
          title="Authorize driver"
          state={addModalOpen}
          toggleState={toggleAddModalOpen}
        >
          <AddDriverToVehicle
            fleetId={fleetId}
            vehicleId={vehicleId}
            authorizedDrivers={authorizedDriversList}
            onCancel={() => toggleAddModalOpen(false)}
          />
        </Modal>
      )}
    </S.Wrapper>
  );
}

export default AuthorizedDrivers;
